export default __webpack_public_path__ + "static/media/ServicePlaceholderIcon.b0b955db.png";